<div class="rangebox">
    <button data-target="#collapseArrivalto" data-toggle="collapse" class="collapsebtn" type="button">Arrival To</button>
    
    
        <div id="collapseArrivalto" class="collapse show ">
            <div class="search-container">
                <input type="text" class="search-input text-capitalize" placeholder="Enter Location">
            </div>
        </div>
    
</div>

